export interface AnalyticsSyncState {
  identifiedUserID?: string
  lastActiveEventKey?: string
  userPropertiesHash?: string
  workspaceKey?: string
}

const ANALYTICS_SYNC_STATE_KEY = 'chain:analytics-sync:v1'

const isStorageAvailable = (): boolean => {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

export const readAnalyticsSyncState = (): AnalyticsSyncState => {
  if (!isStorageAvailable()) return {}

  try {
    const rawSyncState = window.localStorage.getItem(ANALYTICS_SYNC_STATE_KEY)
    if (!rawSyncState) return {}

    const parsedSyncState = JSON.parse(rawSyncState) as AnalyticsSyncState | null
    if (!parsedSyncState || typeof parsedSyncState !== 'object') {
      clearAnalyticsSyncState()
      return {}
    }

    return {
      identifiedUserID:
        typeof parsedSyncState.identifiedUserID === 'string' ? parsedSyncState.identifiedUserID : undefined,
      lastActiveEventKey:
        typeof parsedSyncState.lastActiveEventKey === 'string' ? parsedSyncState.lastActiveEventKey : undefined,
      userPropertiesHash:
        typeof parsedSyncState.userPropertiesHash === 'string' ? parsedSyncState.userPropertiesHash : undefined,
      workspaceKey: typeof parsedSyncState.workspaceKey === 'string' ? parsedSyncState.workspaceKey : undefined
    }
  } catch {
    clearAnalyticsSyncState()
    return {}
  }
}

export const writeAnalyticsSyncState = (syncState: AnalyticsSyncState): void => {
  if (!isStorageAvailable()) return

  try {
    window.localStorage.setItem(ANALYTICS_SYNC_STATE_KEY, JSON.stringify(syncState))
  } catch {
    // Ignore storage write failures and fall back to in-memory dedupe.
  }
}

export const clearAnalyticsSyncState = (): void => {
  if (!isStorageAvailable()) return

  try {
    window.localStorage.removeItem(ANALYTICS_SYNC_STATE_KEY)
  } catch {
    // Ignore storage cleanup failures and rely on runtime guards.
  }
}

export { ANALYTICS_SYNC_STATE_KEY }
